import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';

// T172 (03.11): hasło startowe ustawione przez admina trzeba zmienić przy pierwszym logowaniu.
// Do tego czasu serwer odpowiada na wszystko inne 403 — tu jest jedyne miejsce, gdzie da się wejść.
export const PASSWORD_MIN = 10;

export default function SetPasswordPage() {
  const { refreshUser, logout } = useAuth();
  const navigate = useNavigate();
  const [cur, setCur] = useState('');
  const [nw, setNw] = useState('');
  const [rep, setRep] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const tooShort = nw.length > 0 && nw.length < PASSWORD_MIN;
  const mismatch = rep.length > 0 && nw !== rep;
  const ready = cur.length > 0 && nw.length >= PASSWORD_MIN && nw === rep && nw !== cur;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      await api.changePassword(cur, nw);
      await refreshUser();
      navigate('/');
    } catch (err) {
      setError(err.message || 'Nie udało się zmienić hasła');
    }
    setBusy(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div style={{ fontSize: 32, textAlign: 'center', marginBottom: 8 }}>🔑</div>
        <div className="login-title">Ustaw własne hasło</div>
        <div className="login-sub">Hasło startowe ustawił administrator. Zanim zaczniesz, zmień je na własne, którego nikt inny nie zna.</div>
        {error && <div className="login-error">{error}</div>}
        <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div className="input-group">
            <label>Hasło startowe</label>
            <input type="password" value={cur} onChange={e => setCur(e.target.value)} autoFocus required />
          </div>
          <div className="input-group">
            <label>Nowe hasło (min. {PASSWORD_MIN} znaków)</label>
            <input type="password" value={nw} onChange={e => setNw(e.target.value)} required />
            {tooShort && <span style={{ fontSize: 10, color: '#DC2626' }}>Za krótkie — jeszcze {PASSWORD_MIN - nw.length} zn.</span>}
          </div>
          <div className="input-group">
            <label>Powtórz nowe hasło</label>
            <input type="password" value={rep} onChange={e => setRep(e.target.value)} required />
            {mismatch && <span style={{ fontSize: 10, color: '#DC2626' }}>Hasła się różnią</span>}
          </div>
          <div style={{ fontSize: 11, color: '#64748B' }}>
            Najłatwiej: kilka słów, np. „Lato-w-Ustce-77”. Nie używaj imienia, nazwiska ani ciągów typu 12345678.
          </div>
          <button type="submit" className="btn btn-primary" disabled={!ready || busy}>{busy ? 'Zapisywanie…' : 'Zapisz i przejdź dalej'}</button>
          <button type="button" className="btn btn-ghost" onClick={() => { logout(); navigate('/login'); }}>Wyloguj</button>
        </form>
      </div>
    </div>
  );
}
